import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import {MsalService} from "@azure/msal-angular";
import { Cliente } from '../../../models/Cliente';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class ClienteService
{
  private hostPeticionClientes:string = environment.clientesWSBase;
  constructor(private http: HttpClient,private msalService:MsalService){}

  public getTipoCliente(token:string, empresa:string, cliente:string){
    let url:string = this.hostPeticionClientes + "/Clientes/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
      {
        parameters:
          [
            [
              {
                campo:"empresa",
                operacion:"=",
                valor:empresa
              }
            ],
            [
              {
                campo:"fec_baj",
                operacion:"=",
                valor:"0001-01-01"
              }
            ],
            [
              {
                campo:"cliente",
                operacion:"=",
                valor:cliente.toString()
              }
            ]
          ],
        select:["tipo"]
      };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(response)
          {
            resolve(response);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          }
        });
    });
  }

  public getPrecioNeto(token:string, empresa:string, cliente:string, articulo:string){
    let url:string = this.hostPeticionClientes + "/Clientes/PrecioNeto"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
      {
        empresa: empresa,
        cliente: cliente,
        articulo: articulo
      };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(response)
          {
            resolve(response);
          },
          error(err)
          {
            reject(err);
          }
        });
    });
  }
  public getTieneDeuda(token: string, empresa: string, cliente: string): Promise<boolean> {
    let url: string = this.hostPeticionClientes + "/Clientes/TieneDeuda"
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
    {
      empresa: empresa,
      cliente: cliente
    };

    return new Promise<any>((resolve, reject) => {
      this.http.post(url, arrParams, httpOptions)
        .subscribe
        ({
          next(response) {
            resolve(response);
          },
          error(err) {
            reject(err);
          }
        });
    });
  }
  public getValoresClientes(token:string, delegacion: string):Promise<Cliente[]>
  {
    let url:string = this.hostPeticionClientes + "/Clientes/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
      {
        parameters:
          [
            [
              {
                campo:"empresa",
                operacion:"=",
                valor:delegacion
              }
            ],
            [
              {
                campo:"tipo",
                operacion:"<>",
                valor:"AISA"
              }
            ],
            [
              {
                campo:"fec_baj",
                operacion:"=",
                valor:"0001-01-01"
              }
            ]
          ],
        select:["nombre","cliente","dnicif", "par_012", "par_015"],
        orden:[["nombre","asc"]]
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(response)
        {
          resolve(response);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  /** Compañías de empresa 7*/
  public buscarClientes(token: string): Promise<Cliente[]>
  {
    const url = this.hostPeticionClientes + "/Clientes/";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    const arrParams = {
      parameters: [
        [{ campo: "empresa", operacion: "=", valor: "7000" }],
        [{ campo: "tipo", operacion: "<>", valor: "AISA" }],
        [{ campo: "fec_baj", operacion: "=", valor: "0001-01-01" }]
      ],
      select: ["nombre", "cliente", "dnicif", "par_012", "par_015"],
      orden: [["nombre", "asc"]]
    };

    return new Promise<any>((resolve, reject) => {
      this.http.post(url, arrParams, httpOptions).subscribe({
        next: (response) => resolve(response),
        error: (err) => {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  public getObservacionesCia(token:string,taller:string|number,codCia:string):Promise<string[]>
  {
    let url:string = this.hostPeticionClientes + "/Clientes/JoinClientes"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrParams =
    {
      parameters:
      [
        [{
          campo:"c.empresa",
          operacion:"=",
          valor:taller.toString()
        }],
        [{
          campo:"c.cliente",
          operacion:"=",
          valor:codCia.toString().trim()
        }],
        [{
          campo:"ob.periode",
          operacion:"=",
          valor:"0".toString()
        }]
      ],
      select:["ob.obser"]
    };

    return new Promise<string[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe(
        {
          next(response:any)
          {
            try
            {
              if(response.length>0)
              {
                const lineasObservacion : string[] = response[0].obser.split("\n");
                resolve(lineasObservacion);
              }
              else
              {
                let nada :string[] = ["No hay Observaciones para esta combinación"];
                resolve(nada);
              }
            }
            catch(ex)
            {
              resolve(["No hay Observaciones para esta combinación"]);
            }
          },
          error(err)
          {
            reject(err);
          },
        });
    });
  }
}
